import { useNavigate } from 'react-router';
import { Avatar, Box, Button, Column, Row, Typography } from '@tempmee/react';
import { colors, shadows } from '@tempmee/tailwind';
import { BackButton } from '~/commonComponents/BackButton';

// Specific page header layout: 3-column grid keeps Back button, title, and empty column balanced.
// No DS layout primitive maps to CSS grid with column-area assignments.
const HEADER_GRID_STYLE = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr',
} as const;

// 76px top padding offsets the fixed app navbar height.
const HEADER_PADDING_TOP = 76;

// 73px indent aligns the Back button with the page left edge below the sidebar.
const BACK_BUTTON_INDENT = 73;

interface ProfileSummaryProps {
  job: {
    id: string;
    job_status?: string;
    isOnsiteInterview?: boolean;
    offer_final_reciever?: {
      first_name?: string;
      last_name?: string;
      profile_image?: string | null;
    } | null;
  };
  title: string;
  noBack?: boolean;
}

const ProfileSummary = ({ job, title, noBack }: ProfileSummaryProps) => {
  const navigate = useNavigate();

  return (
    <Box
      style={{
        ...HEADER_GRID_STYLE,
        backgroundColor: 'white',
        width: '100%',
        boxShadow: shadows['elevation-4'],
        zIndex: 1,
        position: 'relative',
        paddingTop: HEADER_PADDING_TOP,
        paddingBottom: 35,
      }}
    >
      {!noBack && (
        <Box style={{ gridArea: '1 / 1', paddingLeft: BACK_BUTTON_INDENT }}>
          <BackButton />
        </Box>
      )}

      <Column align="center" gap={8} style={{ gridArea: '1 / 2' }}>
        <Typography bold size="heading_2" color={colors.neutral[600]} textAlign="center">
          {title}
        </Typography>

        <Row gap={4}>
          <Avatar
            size="2xl"
            src={job.offer_final_reciever?.profile_image || undefined}
            alt="profile_image"
          />
          <Column align="end">
            <Typography bold size="heading_4" color={colors.neutral[600]}>
              {job.offer_final_reciever
                ? `${job.offer_final_reciever.first_name} ${job.offer_final_reciever.last_name}`
                : ''}
            </Typography>
            <Button
              variant="ghost"
              size="inline"
              type="button"
              onClick={() =>
                navigate(`/dashboard/job/${job.id}/details`, {
                  state: {
                    job_status: job.job_status,
                    isPrevScreenFeedback: true,
                  },
                })
              }
            >
              See details
            </Button>
          </Column>
        </Row>
      </Column>
    </Box>
  );
};

export default ProfileSummary;
